import { render, staticRenderFns } from "./InstitutionLimit.vue?vue&type=template&id=e9f75ed6&scoped=true&"
import script from "./InstitutionLimit.vue?vue&type=script&lang=js&"
export * from "./InstitutionLimit.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionLimit.vue?vue&type=style&index=0&id=e9f75ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f75ed6",
  null
  
)

export default component.exports